module.exports = __webpack_public_path__ + "media/images/lb/136-74b8c5eb4d0a2b213b99d9d9ba720c86.svg";